import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capitalize' })
export class CapitalizePipe implements PipeTransform {

  transform(str: string , args: string[]): any {
    return _.capitalize(str);
  }
}
